import { render, staticRenderFns } from "./YoutubeTutorials.vue?vue&type=template&id=046bc4c6"
import script from "./YoutubeTutorials.vue?vue&type=script&lang=js"
export * from "./YoutubeTutorials.vue?vue&type=script&lang=js"
import style0 from "./YoutubeTutorials.vue?vue&type=style&index=0&id=046bc4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports